module.exports = __webpack_public_path__ + "img/undraw_Business_decisions_re_84ag.bee6760a.svg";